import React from 'react';
import { MarketOpportunity } from '../components/MarketOpportunity';
import { BusinessModel } from '../components/BusinessModel';
import { GrowthRoadmap } from '../components/GrowthRoadmap';
import { FundraiseSection } from '../components/FundraiseSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TractionSection } from '../components/TractionSection';
import { VisionSection } from '../components/VisionSection';
import { SiteFooter } from '../components/ui/SiteFooter';
export function InvestorsPage() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-477" data-mp="1ak9aq1acb7l5">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-478" data-mp="11le6uvurq9l0">
        <a href="/" data-id="element-479" data-mp="wnm7xhvphn7b">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-480" data-mp="rm6jdfubkyk6" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-481" data-mp="2exmdsh2t1sx7">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-482" data-mp="208zts228gczn">
            Home
          </a>
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-483" data-mp="257t98012ye2g">
            Get the App
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-484" data-mp="2syf56sxt87w3">
            Practitioners
          </a>
        </div>
      </nav>

      {/* Hero Section for Investors */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-ivory pt-20 pb-20" data-id="element-485" data-mp="2nykfuttonqd5">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-200/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" data-id="element-486" data-mp="17jsw15alrrfg"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-purple-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" style={{
        animationDelay: '2s'
      }} data-id="element-487" data-mp="1chb1glpevoip"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-488" data-mp="35f7xhzdyl7jf">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-purple-200/60 bg-white/30 backdrop-blur-sm mb-8" data-id="element-489" data-mp="30hoj8zh9gurh">
            <span className="text-sm font-medium tracking-wide uppercase text-charcoal/80" data-id="element-490" data-mp="2vjenamnppq4t">
              Investment Opportunity
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] mb-8 tracking-tight" data-id="element-491" data-mp="2migezs68qwgf">
            Building the Future of{' '}
            <span className="italic text-charcoal/80" data-id="element-492" data-mp="kq0lj1ufay7m">Women's Wellness</span>
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 max-w-3xl mx-auto mb-12 font-light leading-relaxed" data-id="element-493" data-mp="kno54t4bcvwo">
            Join us in creating a new category of care — where technology,
            community, and trusted practitioners converge to serve the most
            underserved market in healthcare.
          </p>
        </div>
      </section>

      {/* Investor-focused sections */}
      <MarketOpportunity data-id="element-494" data-mp="x2cov4bmc8de" />
      <BusinessModel data-id="element-495" data-mp="11z363uz5ta0e" />
      <TractionSection data-id="element-496" data-mp="11yba4j1nha9l" />
      <GrowthRoadmap data-id="element-497" data-mp="11ythobtrjawt" />
      <VisionSection data-id="element-498" data-mp="12178g8heu0yk" />
      <LeadershipSection data-id="element-499" data-mp="4bugbns4lesl" />
      <FundraiseSection data-id="element-500" data-mp="4cnq6xmdskey" />

      <SiteFooter currentPath="/investors" data-id="element-501" data-mp="4df9pa2perov" />
    </main>;
}